const FTYP_MARKER = [0x66, 0x74, 0x79, 0x70];

const HEIC_BRANDS = [
  'heic',
  'heix',
  'hevc',
  'hevx',
  'mif1',
  'msf1',
  'heim',
  'heis',
  'hevm',
  'hevs',
];

const MAGIC_NUMBERS = [
  { type: 'jpeg', signatures: [{ offset: 0, bytes: [0xff, 0xd8, 0xff] }] },
  {
    type: 'png',
    signatures: [
      { offset: 0, bytes: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a] },
    ],
  },
  { type: 'gif', signatures: [{ offset: 0, bytes: [0x47, 0x49, 0x46, 0x38] }] },
  {
    type: 'webp',
    signatures: [
      { offset: 0, bytes: [0x52, 0x49, 0x46, 0x46] },
      { offset: 8, bytes: [0x57, 0x45, 0x42, 0x50] },
    ],
  },
];

const matchesSignature = ({ offset, bytes }, buffer) =>
  bytes.every((byte, i) => buffer[offset + i] === byte);

const readBrand = (buffer) =>
  String.fromCharCode(buffer[8], buffer[9], buffer[10], buffer[11]);

function isHeicHeif(buffer) {
  if (buffer.length <= 12) return false;
  if (!FTYP_MARKER.every((byte, i) => buffer[4 + i] === byte)) return false;
  return HEIC_BRANDS.includes(readBrand(buffer));
}

function checkMagicNumber(buffer) {
  if (isHeicHeif(buffer)) return 'heic';
  return (
    MAGIC_NUMBERS.find(({ signatures }) =>
      signatures.every((sig) => matchesSignature(sig, buffer))
    )?.type ?? null
  );
}

export const validateImageFile = async ({ file }) => {
  if (!(file instanceof Blob) || file.size === 0) return false;

  const header = await file.slice(0, 32).arrayBuffer();
  const buffer = new Uint8Array(header);

  return checkMagicNumber(buffer) !== null;
};
